"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleOptions = exports.prizeTypeOptions = exports.prizeItemPicMap = exports.prizeItem = exports.formRules = exports.defaultFormDataMap = exports.defaultFormData = void 0;
var styleOptions = exports.styleOptions = [{
  label: '转盘抽奖',
  value: 1
}, {
  label: '幸运福袋',
  value: 2,
  disabled: true
}, {
  label: '惊喜盲盒',
  value: 3,
  disabled: true
}, {
  label: '幸运九宫格',
  value: 4
}];
var defaultFormData = exports.defaultFormData = {
  activityName: '',
  // 活动名称
  activityStyle: 1,
  // 活动样式
  activityBackPic: '/crmebimage/presets/wheel/lottery_wheel_bg.jpg',
  // 活动背景图
  drawTime: [],
  // 活动时间 开始+结束，纯前端字段，后续需要转换为开始时间和结束时间
  drawStartTime: '',
  // 开始时间
  drawEndTime: '',
  // 结束时间
  remark: '点击“开始”转盘开始转动，最终指针指向的即为您所中的奖品。',
  // 活动说明
  joinType: 1,
  // 参与条件(1=不限,2=消耗积分)
  joinCostPoints: 0,
  // 消耗积分数量
  dailyLimit: 0,
  // 每人每日抽奖总次数
  prizeSaveRequest: []
};
var defaultFormDataMap = exports.defaultFormDataMap = {
  1: {
    activityBackPic: '/crmebimage/presets/wheel/lottery_wheel_bg.jpg',
    remark: '点击“开始”转盘开始转动，最终指针指向的即为您所中的奖品。'
  },
  4: {
    activityBackPic: '/crmebimage/presets/wheel/lottery_grid_bg.png',
    remark: '点击“开始”开始转动，最终停下的即为您所中的奖品。'
  }
};
var prizeItem = exports.prizeItem = {
  awardName: '',
  // 奖项名称
  prizeName: '',
  // 奖品名称
  prizeType: 1,
  // 奖品类型（1:积分;2:实物;99:未中奖）
  pointsValue: 1,
  // 赠送积分值
  prizeNum: 1,
  // 奖品数量
  price: 100,
  // 实物奖品价格
  prizeTitle: '',
  prizeSubTitle: '',
  validityDate: 3,
  // 兑奖有效期(X小时)
  prizePic: '',
  // 奖品图片
  ruleDes: '',
  // 规则说明
  winProbability: 0,
  // 中奖概率（百分比）
  redemptionRule: '前往「专属活动商城页面」购买任一商品，即可解锁奖品福利，完成购买后。奖品与您购买的商品一起发货。',
  // 兑奖规则
  userWinLimit: 1,
  // 奖品每人可中奖次数
  redirectUrl: '',
  // 跳转链接
  sort: 0 // 排序
};
var prizeItemPicMap = exports.prizeItemPicMap = {
  0: '/crmebimage/presets/wheel/prize-default.png',
  // 活动背景图
  99: '/crmebimage/presets/wheel/prize-empty.png' // 活动背景图
};
var prizeTypeOptions = exports.prizeTypeOptions = [{
  label: '积分',
  value: 1
}, {
  label: '实物',
  value: 2
}];
var formRules = exports.formRules = {
  activityName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入活动名称'
  }],
  drawTime: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择活动时间'
  }],
  joinCostPoints: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入消耗积分数量'
  }],
  dailyLimit: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入抽奖次数'
  }],
  activityBackPic: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择活动背景图'
  }]
};